<template>
  <div class="inventory_stock_out">
    <b-container fluid>
      <h1>Stock Out</h1>
      <b-row class="print-hidden">
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>
      
      <b-button class="print-hidden" variant="primary" @click="showModal('modal-add-stock-out')">Add</b-button>
      
      <b-pagination
        class="my-2"
        v-model="currentPage"
        :page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>

      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="fields"
        :filter="filterCriteria"
        :items="displayed_records"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
      
        <template #cell(is_standard)="row">
          <span v-if="row.item.status">YES</span>
          <span v-if="!row.item.status">NO</span>
        </template>

      </b-table>

      <!-- ADD ITEM -->
      <b-modal hide-header-close no-close-on-backdrop :id="'modal-add-stock-out'" hide-footer :title="'Add Stock Out'">
        <b-form @submit.prevent="add_stock_out">
          <label for="locatino">Location:</label>
          <b-form-select
            id="locatino" 
            v-model="input_location" 
            :options="locations"
            required></b-form-select>
            
          <label for="item_code">Item Code:</label>
          <b-form-select
            id="item_code" 
            v-model="input_item_code" 
            :options="inventory_item_code_list"
            required></b-form-select>

          <div v-if="itemFetchedByName">
            <label for="item_type">Type:</label>
            <p>{{new_stock_out.item_type}}</p>

            <label for="item_current_quantity">Current Quantity:</label>
            <p>{{addItemLimitation}}</p>

            <label for="invoice_number">Invoice #:</label>
            <b-input type="text" 
              id="invoice_number" 
              v-model="new_stock_out.invoice_number" 
              required></b-input>

            <label for="date">Date:</label>
            <b-form-datepicker type="text"
              id="date"
              v-model="new_stock_out.date"
              class="form-control"></b-form-datepicker>

            <!-- <label for="item_size">Size & Colour:</label>
            <b-form-select
              id="item_size" 
              v-model="size_n_colour_input_add" 
              :options="size_n_colour_input_add_list"
              required></b-form-select> -->

            <label for="item_quantity">Quantity:</label>
            <b-input type="number" 
              id="item_quantity" 
              min="0"
              :max="addItemLimitation"
              v-model="new_stock_out.item_quantity" 
              required></b-input>

            <label for="comment">Comment:</label>
            <b-textarea type="text" 
              id="comment" 
              v-model="new_stock_out.comment" 
              rows="2"></b-textarea>

          </div>

          <div class="modal-footer mt-4">
            <b-button @click="resetInputs"> Cancel </b-button>
            <b-button v-if="!itemFetchedByName" variant="primary" @click="fetchItemByName()"> Next </b-button>
            <b-button v-if="itemFetchedByName" type="submit" variant="primary">
              <span v-if="!is_submitting">Add</span>
              <span v-if="is_submitting">
                <b-spinner small type="grow"></b-spinner>
                Submitting...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- VIEW ITEM -->
      <b-modal no-close-on-backdrop :id="'modal-view-stock-out' + location" hide-footer title="View Stock Out">
        <b-form @submit.prevent="update_stock_out">
          <label for="locatino">Location:</label>
          <p>{{viewed_stock_out.location}}</p>

          <label for="item_code">Code:</label>
          <p>{{viewed_stock_out.item_code}}</p>

          <label for="invoice_number">Invoice #:</label>
          <p>{{viewed_stock_out.invoice_number}}</p>

          <label for="date">Date:</label>
          <b-form-datepicker type="text"
            id="date"
            v-model="viewed_stock_out.date"
            class="form-control"></b-form-datepicker>

          <label for="item_type">Type:</label>
          <p id="item_type">{{viewed_stock_out.item_type}}</p>

          <!-- <label for="item_size">Size & Colour:</label>
          <p id="item_size">{{viewed_stock_out.item_size}}</p> -->

          <label for="item_quantity">Quantity: </label>
          <p id="item_size">{{viewed_stock_out.item_quantity}}</p>

          <label for="comment">Comment:</label>
          <b-textarea type="text" 
            id="comment" 
            v-model="viewed_stock_out.comment" 
            rows="2"></b-textarea>

          <div class="modal-footer mt-4">
            <b-button @click="delete_confirmation()" variant="danger">Delete</b-button>
            <b-button @click="hideModal('modal-view-stock-out')"> Close </b-button>
            <b-button type="submit" variant="warning">
              <span v-if="!is_updating">Update</span>
              <span v-if="is_updating">
                <b-spinner small type="grow"></b-spinner>
                Submitting...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- DELETE CONFIRMATION -->
      <b-modal
        no-close-on-backdrop
        :id="'modal-delete-confirmation' + location"
        title="Delete confirmation"
        hide-footer
      >
        <p>This operation will delete a record.</p>
        <div class="modal-footer mt-1">
          <b-button
            variant="secondary"
            @click="hideModal('modal-delete-confirmation')"
          >
            Cancel
          </b-button>
          <b-button
            :disabled="is_deleting"
            variant="danger"
            @click="delete_record()"
          >
            <span v-if="!is_deleting">Delete</span>
            <span v-if="is_deleting">
              <b-spinner small type="grow"></b-spinner>
              Deleting...
            </span>
          </b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  props: {
    user: Object,
  },
  computed: {
    rows: {
      get() {
        if (this.displayed_records.length == 0) {
          return 100;
        } else {
          return this.displayed_records.length;
        }
      },
      set(newRows) {
        return newRows;
      },
    },
  },
  data() {
    return {
      fetchedAccessoryOrders: [],
      addItemLimitation: 0,
      size_n_colour_input_add: "",
      size_n_colour_input_add_list: [],
      size_n_colour_input_view: "",
      size_n_colour_input_view_list: [],
      itemFetchedByName: false,
      new_stock_out_sizes: [],
      new_stock_out_colours: [],
      fetchedItem: {},
      input_location: "",
      input_item_code: "",
      item_types: ['Cross', 'Door', 'Decoration', 'Lantern', 'Photo Frame', 'Vase Insert', 'Lid', 'Other'],
      locations: ["DAN", "TH"],
      location: "",
      inventory_item_code_lists: {},
      inventory_item_code_list: [],
      inventory_item_code_list_dan: [],
      inventory_item_code_list_th: [],
      items: [],
      origin: {},
      fields: [
        { key: 'invoice_number', label: 'Invoice #'},
        { key: 'date', label: 'Date'},
        { key: 'item_type', label: 'Type'},
        { key: 'item_code', label: 'Code'},
        { key: 'item_size', label: 'Size'},
        { key: 'item_colour', label: 'Colour'},
        { key: 'item_quantity', label: 'QTY'},
        { key: 'location', label: 'Location'},
        { key: 'comment', label: 'Comment'},
        { key: 'creator_name', label: 'Creator'},
      ],
      filterCriteria: "",
      displayed_records: [],
      records: [],
      perPage: 20,
      currentPage: 1,
      tableIsBusy: false,
      new_stock_out: {
        id: "",
        invoice_number: "",
        creator: {},
        creator_name: "",
        item_type: "",
        item_code: "",
        item_size: "",
        item_colour: "",
        item_quantity: 0,
        location: "",
        date: "",
        comment: "",
      },
      viewed_stock_out: {
        id: "",
        invoice_number: "",
        creator: {},
        creator_name: "",
        item_type: "",
        item_code: "",
        item_size: "",
        item_colour: "",
        item_quantity: 0,
        location: "",
        date: "",
        comment: "",
      },
      is_submitting: false,
      is_updating: false,
      is_deleting: false,
    };
  },
  methods: {
    resetInputs() {
      this.input_location = "";
      this.input_item_code = "";
      this.new_stock_out.invoice_number = "";

      this.itemFetchedByName = false;
      this.hideModal('modal-add-stock-out');
    },
    fetchItemByName() {
      this.size_n_colour_input_add_list = [];
      this.size_n_colour_input_add = "";
      this.new_stock_out.item_quantity = "";
      this.new_stock_out.container_number = "";
      this.new_stock_out.comment = "";

      this.new_stock_out_sizes = [];
      this.new_stock_out_colours = [];
      if (this.new_stock_out.item_code.length == 0 || this.input_location.length == 0) {
        alert("Please enter item code.");
        return;
      }

      firebase.firestore()
        .collection("inventory_test")
        .where("location", "==", this.input_location)
        .where("item_code", "==", this.new_stock_out.item_code)
        .get().then((collection) => {
        this.fetchedItem = collection.docs.map((doc) => doc.data())[0];
        
        console.log(this.fetchedItem);
        
        this.new_stock_out.item_type = this.fetchedItem.item_type;
        this.addItemLimitation = parseInt(this.fetchedItem.quantity);

        for (var i = 0; i < this.fetchedItem.variants.length; i++) {
          this.size_n_colour_input_add_list.push(this.fetchedItem.variants[i].size + '/' + this.fetchedItem.variants[i].colour + '/Remainning: ' + this.fetchedItem.variants[i].quantity);
        }

        this.itemFetchedByName = true;
      });
    },
    myRowClickHandler(item) {
      console.log(item);
      this.viewed_stock_out = Object.assign({}, item);
      //this.origin = Object.assign({}, item);
      this.showModal('modal-view-stock-out');
    },
    cleanFilterInfo() {
      this.filterCriteria = '';
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, '0');
      var mm = String(date_time.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
      this.new_stock_out.date = this.today;
    },
    add_stock_out() {
      console.log("Add Stock Out");

      const new_stock_out_ref = firebase.firestore().collection('stock_out_records_test').doc();

      //this.new_stock_out.item_type = this.items[this.new_stock_out.item_code].item_type;
      this.new_stock_out.item_code = this.new_stock_out.item_code;
      this.new_stock_out.id = new_stock_out_ref.id;
      this.new_stock_out.created_date = this.today;
      this.new_stock_out.year_month = this.new_stock_out.created_date.substring(
        0,
        7
      );
      this.new_stock_out.day = parseInt(
        this.new_stock_out.created_date.substring(8, 10)
      );
      this.new_stock_out.creator = this.user;
      this.new_stock_out.creator_name = this.user.name;
      this.new_stock_out.location = this.input_location;

      console.log(this.new_stock_out);

      const exisiting_item_ref = firebase.firestore().collection("inventory_test").where("location", "==", this.new_stock_out.location).where('item_code', '==', this.new_stock_out.item_code);
      exisiting_item_ref.get().then((collection) => {
        var exisiting_item = collection.docs.map(doc => doc.data())[0];
        console.log(exisiting_item);
        if (exisiting_item != null) {
          exisiting_item.quantity = parseInt(exisiting_item.quantity) - parseInt(this.new_stock_out.item_quantity);
          
          if (exisiting_item.quantity >= 0) {
          const item_ref = firebase.firestore().collection('inventory_test').doc(exisiting_item.id);
          item_ref.set(exisiting_item, { merge: true });
          this.is_submitting = true;
          new_stock_out_ref
            .set(this.new_stock_out, { merge: true })
            .then(() => {
            this.new_stock_out = {
              id: "",
              invoice_number: "",
              creator: {},
              creator_name: "",
              item_type: "",
              item_code: "",
              item_size: "",
              item_colour: "",
              item_quantity: 0,
              location: "",
              date: "",
              comment: "",
            };

            this.is_submitting = false;
            this.hideModal('modal-add-stock-out');
            alert('Create successfully.');
            });
          }
        } else {
          alert('No enough items');
        }
      });
    },
    update_stock_out() {
      this.viewed_stock_out.item_code = this.viewed_stock_out.item_code.toLowerCase().trim();
      firebase.firestore().collection("inventory_test").where('item_code', '==', this.viewed_stock_out.item_code).get().then((collection) => {
        var exisiting_items = collection.docs.map(doc => doc.data());
        if (exisiting_items.length > 0) {
          exisiting_items.forEach((element) => {
            element.item_number_in_stock = 0 - parseInt(this.viewed_stock_out.item_quantity) + parseInt(this.origin.item_quantity) + parseInt(element.item_number_in_stock);
            if (element.item_number_in_stock >= 0) {
              const element_ref = firebase.firestore().collection('inventory').doc(element.id);
              element_ref.set(element, { merge: true });
              this.is_updating = true;
              firebase
              .firestore()
              .collection("stock_out_records_test")
              .doc(this.viewed_stock_out.id)
              .set(this.viewed_stock_out, { merge: true })
              .then(() => {
                this.is_updating = false;
                alert("Modify successfully");
              });
            } else {
              alert('No enough items.');
            }
          });
        }
      });
    },
    delete_confirmation() {
      this.showModal('modal-delete-confirmation');
    },
    delete_record() {
      this.is_deleting = true;
      firebase
        .firestore()
        .collection("stock_out_records_test")
        .doc(this.viewed_stock_out.id)
        .delete().then(() => {
          firebase.firestore()
            .collection("inventory_test")
            .where("location", "==", this.viewed_stock_out.location)
            .where('item_code', '==', this.viewed_stock_out.item_code)
            .get().then((collection) => {
            var exisiting_item = collection.docs.map(doc => doc.data())[0];
            console.log(exisiting_item);

            exisiting_item.variants.forEach((element) => {
              if (element.size == this.viewed_stock_out.item_size && element.colour == this.viewed_stock_out.item_colour) {
                element.quantity = (parseInt(element.quantity) + parseInt(this.viewed_stock_out.item_quantity)).toString();
              }
            });

            const exisiting_item_ref = firebase.firestore().collection('inventory_test').doc(exisiting_item.id);
            exisiting_item_ref.set(exisiting_item, { merge: true });
          });

          alert('Delete successfully.');
          this.is_deleting = false;
          this.hideModal('modal-view-stock-out');
          this.hideModal('modal-delete-confirmation');
          
        });
    },
  },
  created() {
    this.set_global_date();

    firebase.firestore().collection("stock_out_records_test").orderBy('invoice_number', "desc").onSnapshot((collection) => {
      this.records = [];
      this.records = collection.docs.map(doc => doc.data());
      this.displayed_records = this.records;
    });

    firebase.firestore().collection("inventory_test").orderBy('item_code', "asc").onSnapshot((collection) => {
      let items = collection.docs.map(doc => doc.data());
      for (let i = 0; i < items.length; i++) {
        if (this.inventory_item_code_lists[items[i].location] == null) {
          this.inventory_item_code_lists[items[i].location] = []
        }
        this.inventory_item_code_lists[items[i].location].push(items[i].item_code);
      }
      console.log(this.inventory_item_code_lists);
    });

    // firebase.firestore().collection("parameters").doc("inventory_info").get().then((doc) => {
    //   this.inventory_item_code_list_dan = doc.data().inventory_item_code_list_dan;
    //   this.inventory_item_code_list_th = doc.data().inventory_item_code_list_th;
    // });
  },
  watch: {
    // size_n_colour_input_add(new_size_n_colour_input_add) {
    //   if (new_size_n_colour_input_add.length > 0) {
    //     const words = new_size_n_colour_input_add.split('/');
    //     this.new_stock_out.item_size = words[0];
    //     this.new_stock_out.item_colour = words[1];
    //     this.addItemLimitation = parseInt(words[2].substring('/Remainning: '.length - 1, words[2].length));
    //   }
    // },
    input_location(new_input_location) {
      this.new_stock_out.item_code = "";
      this.itemFetchedByName = false;

      this.inventory_item_code_list = this.inventory_item_code_lists[new_input_location];
    },
    input_item_code(new_item_code) {
      this.itemFetchedByName = false;
      this.new_stock_out.item_code = new_item_code;
    }
  }
}
</script>